import { ChevronUp } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function ScrollToTopButton() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const root = document.getElementById('root');
    if (!root) return;
    const onScroll = () => setVisible(root.scrollTop > 400);
    root.addEventListener('scroll', onScroll, { passive: true });
    return () => root.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      onClick={() => {
        const root = document.getElementById('root');
        if (root) root.scrollTo({ top: 0, behavior: 'smooth' });
      }}
      aria-label={t('common.scrollToTop')}
      className={`fixed bottom-20 right-4 md:bottom-8 md:right-8 z-30 w-10 h-10 rounded-full bg-ivory border border-line shadow-soft text-ink-3 hover:bg-ivory-2 hover:border-ink hover:text-rust flex items-center justify-center transition-all duration-200 ${
        visible
          ? 'opacity-100 pointer-events-auto'
          : 'opacity-0 pointer-events-none'
      }`}
    >
      <ChevronUp className="w-4 h-4" />
    </button>
  );
}
